export { default as RecommendationsFragment } from './BlogRecommendations';